'use client'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import { Control, Controller, FieldValues } from 'react-hook-form'

type Props = {
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year'
  placeholder?: string
  control?: Control<FieldValues, any>
  name: string
  label?: string
  required?: boolean
  className?: string
}

export const DatePickerCT = ({ label, picker, required, className, placeholder, control, name }: Props) => {
  return (
    <div className="relative w-full">
      {label && (
        <p className="text-[16px] font-semibold leading-4 text-[#494949]">
          {label} {required ? <span className="text-red-700">*</span> : null}
        </p>
      )}
      {control ? (
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DesktopDatePicker
                  label="Basic date picker"
                  {...field}
                  value={!!field.value ? dayjs(field.value) : null}
                  className={`peer relative !mt-5 w-full !rounded-lg !border-[1px] border-x-0 border-t-0 text-black focus:border-primary focus:outline-none focus:ring-0 ${className} customDatePicker`}
                />
              </DemoContainer>
            </LocalizationProvider>
          )}
        />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DesktopDatePicker
              className={`peer relative !mt-5 w-full !rounded-lg !border-[1px] border-x-0 border-t-0 text-black focus:border-primary focus:outline-none focus:ring-0 ${className} customDatePicker`}
            />
          </DemoContainer>
        </LocalizationProvider>
      )}
    </div>
  )
}
